import * as yup from 'yup';
import { format, isBefore } from 'date-fns';

export const buscarActaPorArticulosSchema = yup.object().shape({
  fecha_inicio: yup
    .string()
    .required('La fecha de inicio del acta es requerida')
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .test('mayor_que_hoy', 'La fecha de inicio no puede ser mayor que ahora', (value, context) => {
      return isBefore(format(value, 'yyyy-MM-dd'), format(new Date(), 'yyyy-MM-dd'));
    })
    .test('mayor_que_fecha_fin', 'La fecha de inicio no puede ser mayor que la fecha fin', (value, context) => {
      if (context.parent.fecha_fin) {        
        const beforeOrEqual =
          isBefore(format(value, 'yyyy-MM-dd'), format(context.parent.fecha_fin, 'yyyy-MM-dd')) ||
          value === context.parent.fecha_fin;
        return beforeOrEqual;
      }
      return true;
    }),
  fecha_fin: yup
    .string()
    .required('La fecha de fin del acta es requerida')
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .test('mayor_que_hoy_fin', 'La fecha fin no puede ser mayor que ahora', (value, context) => {
      return isBefore(format(value, 'yyyy-MM-dd'), format(new Date(), 'yyyy-MM-dd'));
    }),
});
